<template>
  <v-card ref="form">
    <v-expansion-panel id="buyerInfo" >
      <v-expansion-panel-content :value="expansion">
        <template v-slot:header>
          <div>
             <v-card-title class="primary white--text">
              <!-- Added when transferring invoice by creating new -->
              <h3 color="primary" v-if="newBuyer">ADD USER INFORMATION</h3>
              <h3 color="primary" v-else>PERSONAL INFORMATION - <b>{{name.value}}</b></h3>
            </v-card-title>
          </div>
        </template>
        <v-form ref="buyerform" v-model="userInfoIsValid" lazy-validation>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  ref="name"
                  v-model="name.value"
                  counter="100"
                  maxlength="100"
                  :rules="name.rules"
                  label="Name"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  ref="propName"
                  v-model="propName.value"
                  counter="100"
                  maxlength="100"
                  :rules="propName.rules"
                  label="Proprietor's Name"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  ref="age"
                  type="number"
                  v-model="age.value"
                  :rules="age.rules"
                  label="Age"
                  maxlength="3"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-select v-model="gender.value" :items="gGender" label="Gender"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-select v-model="identityType.value" :items="gIdentityType" clearable label="Identity Type"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="identityType.value">
                <v-text-field
                  ref="identityNumber"
                  :error-messages="identityNumeberError"
                  v-model="identityNumber.value"
                  :rules="identityNumber.rules"
                  label="Identity Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  type="number"
                  ref="mobile"
                  v-model="mobile.value"
                  :rules="mobile.rules"
                  label="Mobile"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field ref="email" type="email" v-model="email.value" :rules="email.rules" label="Email"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm3 md3>
                <v-text-field type="number" @change="setLocationBasedOnZipCode()" ref="zipCode" v-model="zipCode" label="ZipCode"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-combobox
                  ref="localAddress"
                  autocomplete="false"
                  v-model="localAddress.value"
                  counter="100"
                  maxlength="100"
                  :items="addressSuggestions"
                  :rules="localAddress.rules"
                  label="Address"
                  required
                ></v-combobox>
              </v-flex>  
              <v-flex xs12 sm3 md3>
                <v-select clearable v-model="tehsil.value" :items="gTehsil" label="Tehsil"></v-select>
              </v-flex>
              <!-- <v-flex xs12 sm6 md3>
                <v-select clearable v-model="village.value" :items="gVillage" label="Village"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-select clearable v-model="block.value" :items="gBlock" label="Block"></v-select>
              </v-flex> -->
              <v-flex xs12 sm6 md4>
                <v-select clearable v-model="district.value" :items="gDistrict" label="District"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-select clearable v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-select clearable v-model="country.value" :items="gCountry" label="Country"></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md2 v-if="state.value">
                <v-select 
                  v-model="GST_user.value" 
                  :items="['Yes','No']" 
                  label="GST User">
                </v-select>
              </v-flex>
              <!-- <v-flex xs12 sm6 md2 v-if="GST_user.value === 'Yes'">
                <v-select
                  v-model="GST_type.value"
                  :disabled="GST_user.value != 'Yes'"
                  :items="gGST_Type"
                  label="GST Scheme"
                ></v-select>
              </v-flex> -->
              <v-flex xs12 sm6 md4 v-if="GST_user.value === 'Yes'">
                <v-text-field
                  type="text"
                  :disabled="GST_user.value != 'Yes'"
                  v-model="GST_number.value"
                  :rules="GST_number.rules"
                  label="GST number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2  v-if="GST_user.value === 'Yes'">
                <v-select 
                  v-model="firm_type.value" 
                  :items="gFirmType" 
                  label="Firm Type">
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-select v-model="purchaseType.value" :items="gPurchaseType" :label="this.isBuyer ? 'Sale Type' : 'Purchase Type'"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md2 >
                <v-select 
                  v-model="category" 
                  :items="filteredProductRateCategories" 
                  label="User Category">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-spacer />
              <v-btn 
                class="grey white--text" 
                flat 
                @click="clear">
                Reset
              </v-btn>
              <v-btn
                class="primary white--text"
                flat
                :disabled="!userInfoIsValid"
                @click="submit"
                  >{{isCreateOrUpdate}}
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-form>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import axios from 'axios';

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerActions = createNamespacedHelpers("Buyer")["mapActions"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];

export default {
  props: {
    isBuyer: {
    },
    newBuyer: {
    },
    buyers : {
      type: Array
    },
    sellers : {
      type: Array
    },
    firms : {
      type: Array
    },
    buyerIdProvided : {
    },
    productRateCategories : {
      type : Array
    }
  },
  data() {
    return {
      userInfoIsValid: false,
      formHasErrors: false,
      snackbar: false,
      expansion : false,
      timeout: 3000,
      valid: true,
      zipCode : null,
      addressSuggestions : [],
      errorMessages: [],
      name: {
        value: "",
        rules: [
          v => !!v || "Name is required",
          v => (v && v.length <= 50) || "Name must be less than 100 characters",
          v => (v && v.length >= 3) || "Name must be more than 3 characters"
        ]
      },
      propName: {
        value: ""
      },
      localAddress: {
        value: "",
      },
      identityType: {
        value: ""
      },
      identityNumber: {
        value: ""
      },
      mobile: {
        value: "",
        rules: [
          v =>{
            if(!v) {
              return true;
            } 
              else {
                return (/^$/.test(v) ||
                  /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) ||
                  "Mobile number is wrong")
              }
            }
        ]
      },
      email: {
        value: "",
        rules: [
        v =>{
          if(!v) {
            return true;
          } 
          else {
            return (/^$/.test(v) ||
              /.@./.test(v) ||
              "E-mail must be valid")
            }
          }
        ]
      },
      village: {
        value: ""
      },
      block: {
        value: ""
      },
      tehsil: {
        value: ""
      },
      district: {
        value: ""
      },
      state: {
        value: ""
      },
      country: {
        value: ""
      },
      GST_user: {
        value: ""
      },
      GST_type: {
        value: ""
      },
      openingBalance: {
        value: 0
      },
      openingBalanceDate: {
        value: null
      },
      datepicker : null,
      GST_number: {
        value: "",
        rules: [
          v => {
            let obj = this.gState.find(o => o.state === this.state.value);
            let reg = /^$/;
            if (obj && obj.code) {
              reg = new RegExp("^(["+obj.code+"]){2}[A-Z\\a-z]{5}\\d{4}[A-Z\\a-z]{1}[A-Z\\a-z\\d]{1}[Z\\z]{1}[A-Z\\a-z\\d]{1}");
            }
            return (
              v == undefined ||
              /^$/.test(v) ||
              reg.test(v) ||
              "GST number must be Valid"
            );
          }
        ]
      },
      firm_type: {
        value: ""
      },
      category : "",
      purchaseType: {
        value: ""
      },
      age: {
        value: ""
      },
      gender: {
        value: ""
      },
    };
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    ...mapGlobalGetters({
      gIdentityType: "identityType",
      gVillage: "village",
      gBlock: "block",
      gTehsil: "tehsil",
      gDistrict: "district",
      gState: "state",
      gCountry: "country",
      gGender: "gender",
      gGST_Type: "GST_Type",
      gFirmType: "firmType",
      gPurchaseType: "purchaseType"
    }),
    ...mapBuyerGetters(["selectedBuyer"]),
    form() {
      return {
        name: this.name,
        propName: this.propName,
        localAddress: this.localAddress,
        identityNumber: this.identityNumber,
        mobile: this.mobile
      };
    },
    isCreateOrUpdate() {
      if (this.newBuyer) {
        return "Create & Transfer";
      }
      if (this.selectedBuyer === "-1" || this.buyerIdProvided === "") {
        return "Create";
      } else {
        return "Update";
      }
    },
    getBuyers() {
      return this.buyers.filter(
        item => item["brand"] === this.selectedBrand
      );
    },
    getSeller() {
      return this.sellers.filter(
        item => item["brand"] === this.selectedBrand
      );
    },
    filteredProductRateCategories(){
      return this.productRateCategories.map((cat)=>{
        return {
          text : cat.name,
          value : cat['.key']
        }
      })
    },
    candidate() {
      if (this.isBuyer) {
        return this.getBuyers;
      } else {
        return this.getSeller;
      }
    },
    // candidate() {
    //   if (this.isBuyer) {
    //     return this.buyers;
    //   } else {
    //     return this.seller;
    //   }
    // },
    identityNumeberError() {
      if(this.identityNumber.value) {
        let error = null;
        switch(this.identityType.value) {
          case "Voter ID":
            // 3 alpha, 7 digit 
            error = /^([a-zA-Z]){3}([0-9]){7}?$/g.test(this.identityNumber.value) ? null : 'Enter valid Voter ID';
            break;
          case"Adhaar ID":
            // 16 or 12 digit number 
            error = /^(\d{16}|\d{12})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Adhaar ID'
            break;
          case"Driving License":
            // 2 alpha, 2 digit, 4 digit, 7 digit  
            error = /^([a-zA-Z]{2})(\d{2})(\d{4})(\d{7})$/g.test(this.identityNumber.value) ? null : 'Enter valid Driving License'
            break;
          case"Pan Card":
            // 5 alpha, 4 digit, 1 alpha 
            error = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/g.test(this.identityNumber.value) ? null : 'Enter valid PAN Card'
            break;
          case"Samagra Id":
            // 9 digit number  
            error = /^(\d{9})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Samagra ID'
            break;
          default: 
            error = 'Select Identity type';
            break;
        }
        return error;
      }
    },
  },
  created() {
    this.addressSuggestions = sessionStorage.getItem("addressSuggestions").split(',');
    setTimeout(() => {
      if(this.$route.params.buyerId == -1) {
        this.expansion = true;
      } else {
        this.loadBuyer(this.$route.params.buyerId);
        this.expansion = false;
      }

      if(this.buyerIdProvided) {
        debugger
        this.SET_SELECTED_CUSTOMER(this.buyerIdProvided);
        this.loadBuyer(this.buyerIdProvided);
        this.expansion = true;
      }
    }, 1000);
    
    if (this.newBuyer) {
      this.selectedBuyer = -1;
      
    } else {
      const { buyerId } = this.$route.params;
      if (buyerId !== "-1" && buyerId) {
        this.SET_SELECTED_CUSTOMER(buyerId);
      } else {
        this.clear()
      }
    }
  },
  destroyed() {
    // this.$unbind('buyers')
  },
  watch: {
    selectedBuyer(nval, oval) {
      if (oval !== nval) {
        this.loadBuyer(nval);
        if(nval == -1 || this.buyerIdProvided) {
          this.expansion = true;
          // this.getAndSetDefaultValues();
        } else {
          this.expansion = false;
        }
      }
    },
    selectedBrand() {
      // this.getAndSetDefaultValues();
    },
    candidate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.loadBuyer(this.selectedBuyer);
      }
    },
    "GST_user.value": {
      handler(newVal, oldVal) {
        if (newVal === "No") {
          this.GST_type.value = "";
          this.GST_number.value = "";
        }
      },
      deep: true
      },
    '$route.params.buyerId': function (id) {
      if(id == -1) {
        this.expansion = true;
        this.clear()
      } else {
        this.expansion = false;
      }
    }
  },
  mounted() {
    // this.identityType.value = this.gIdentityType[0];
    // this.village.value = this.gVillage[0];
    // this.block.value = this.gBlock[0];
    // this.tehsil.value = this.gTehsil[0];
    // this.district.value = this.gDistrict[0];
    // this.state.value = this.gState[0];
    // this.country.value = this.gCountry[0];
  },
  methods: {
    ...mapBuyerActions(["ADD_CUSTOMER", "SET_SELECTED_CUSTOMER"]),
    setLocationBasedOnZipCode(){
      let reg = /^[1-9][0-9]{5}$/;
      console.log(this.zipCode)
      if(this.zipCode && reg.test(this.zipCode)) {
        console.log("change")
        axios
          .get('https://api.postalpincode.in/pincode/'+this.zipCode)
          .then(response => {
            let data = response.data[0].PostOffice[0];
            this.gDistrict.push(data.District);
            this.gTehsil.push(data.Block);
            setTimeout(() => {
              this.country.value = data.Country;
              this.district.value = data.District;
              this.state.value = data.State;
              this.tehsil.value = data.Block;
            }, 100);
        })
      }
    },
    submit() {
        const data = {
          brand: this.selectedBrand,
          name: this.name.value,
          propName: this.propName.value,
          localAddress: this.localAddress.value,
          identityType: this.identityType.value,
          identityNumber: this.identityNumber.value,
          mobile: this.mobile.value,
          village: this.village.value,
          block: this.block.value,
          tehsil: this.tehsil.value,
          district: this.district.value,
          state: this.state.value,
          country: this.country.value,
          age: this.age.value,
          gender: this.gender.value,
          // updatedAt: -1 * new Date().getTime(),
          email: this.email.value,
          firm_type: this.firm_type.value,
          category : this.category,
          GST_user: this.GST_user.value,
          purchaseType: this.purchaseType.value,
          zipCode: this.zipCode,
        }
        if(data.identityType && !data.identityNumber) {
          return alert('Identity number is required')
        }
        if(data.identityNumber && !data.identityType) {
          return alert('Identity type is required')
        }
        // if nothing is selected
        if(!data.identityType && !data.identityNumber) {
          delete data.identityType;
          delete data.identityNumber;
        }
        if (this.GST_user.value == "Yes") {
          data["GST_type"] = this.GST_type.value;
          data["GST_number"] = this.GST_number.value;
        }
        if (this.openingBalance.value) {
          data["openingBalance"] = this.openingBalance.value;
        }
        if (this.openingBalanceDate.value) {
          data["openingBalanceDate"] = new Date(this.openingBalanceDate.value).getTime()
        }
        if (
          this.selectedBuyer === "-1" ||
          this.selectedBuyer === undefined ||
          this.selectedBuyer === null ||
          this.newBuyer
        ) {
          data["createdAt"] = -1 * new Date().getTime();
          this.addBuyer(data);
        } else {
          let candidate = this.candidate.filter(item=> item['.key'] == this.selectedBuyer)[0]
          let updatedData = {
            ".key": this.selectedBuyer,
            updatedAt: -1 * new Date().getTime(),
            ...candidate,
            ...data
          };
          this.updateBuyer(updatedData);
        }
    },
    isUnique(buyer) {
      let buyers = this.getBuyers.filter(
        item => item[".key"] !== buyer[".key"]
      );

      // Mobile Check
      let byMobile = buyers.filter(item => item["mobile"] === buyer["mobile"]);

      if (byMobile.length > 0 && !!buyer["mobile"]) {
        return 1;
      }

      // Identity check

      if(buyer['identityNumber'] || buyer['identityType']) {
        let byIdentity = buyers.filter(item => 
          (item['identityNumber'] === buyer['identityNumber'] && item['identityType'] === buyer['identityType'])
        )
  
        if (byIdentity.length > 0 && !!buyer["identityNumber"]) {
          return 2
        }
      }

      // GST Number
      if(buyer['GST_number'] && buyer['GST_user']) {
        let byGST = buyers.filter(item => 
          (item['GST_number'] === buyer['GST_number'] && item['GST_user'] === buyer['GST_user'])
        )
        if (byGST.length > 0 && !!buyer["GST_number"]) {
          return 3
        }
      }
      return 0;
    },

    addBuyer: function(candidate) {
      let code = this.isUnique(candidate);
      if (code != 0) {
        if (code == 1) {
          let byMobile = this.getBuyers.filter(item => item["mobile"] === candidate["mobile"]);
          alert("Duplicate Mobile number found -  " + candidate["mobile"] + " already belong to " + byMobile[0]["name"] + ".");
        }
        else if (code == 2) {
          let byIdentity = this.getBuyers.filter(item => item["identityNumber"] === candidate["identityNumber"]);
          alert("Duplicate Identity number found -  " + candidate["identityNumber"] + " already belong to " + byIdentity[0]["name"] + ".");
        }
        else if (code == 3) {
          let byGST = this.getBuyers.filter(item => item["GST_number"] === candidate["GST_number"]);
          alert("Duplicate GST number found -  " + candidate["GST_number"] + " already belong to " + byGST[0]["name"] + ".");
        }
        return;
      }
      let response = null;
      if (this.isBuyer) {
        response = this.$root.$firebaseRefs.buyer.push(candidate);
        this.snackbar = true;
        this.snackbarText = "Buyer added succesfully";
      } else {
        response = this.$root.$firebaseRefs.seller.push(candidate);
        this.snackbar = true;
        this.snackbarText = "Seller added succesfully";
      }
      if (this.newBuyer) {
        // new buyer create to tranfer emit the event
        this.$emit("onCreate", response["key"]);
      } else {
        this.SET_SELECTED_CUSTOMER(response["key"]);
        this.$router.push({ path: `/buyers/${response["key"]}` });
      }
    },
    updateBuyer: function(item) {
      let code = this.isUnique(item);
      if (code != 0) {
        if (code == 1) 
          alert("Mobile Number already Exists");
        else if (code == 2) 
          alert("Identity Number already Exists");
        else if (code == 3) 
          alert("GST Number already Exists");
        return;
      }
      const copy = { ...item };
      delete copy[".key"];
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.child(item[".key"]).set(copy);
        alert("Buyer Updated");
      } else {
        this.$root.$firebaseRefs.seller.child(item[".key"]).set(copy);
        alert("Seller Updated");
      }
    },
    clear() {
      let defaultFirm = this.firms.filter(
        (item) =>
          item["brand"] === this.selectedBrand && !!item["defaultFirm"]
      )[0];
      let selectedFirmState = defaultFirm["state"];
      this.errorMessages = []
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if(this.$refs[f]) {
          this.$refs[f].reset()
        }
      })
      this.name.value = ""
      this.propName.value = ""
      this.localAddress.value = ""
      this.identityType.value = ""
      this.identityNumber.value = ""
      this.mobile.value = ""
      this.village.value = ""
      this.block.value = ""
      this.tehsil.value = ""
      this.district.value = ""
      this.state.value = selectedFirmState
      this.country.value = ""
      this.age.value = ""
      this.gender.value = ""
      this.GST_type.value = ""
      this.firm_type.value = ""
      this.category = ""
      this.purchaseType.value = ""
      this.email.value = ""
      this.GST_number.value = ""
      this.GST_user.value = "";
      this.zipCode= "";
      this.openingBalance.value = 0,
      this.openingBalanceDate.value = null
    },
    loadBuyer(val) {
      if (val !== "-1" && this.candidate) {
        if (this.candidate.length) {
          let candidate = this.candidate.filter(item=> item['.key'] == val)[0]
          if (candidate) {
            const {
              name,
              propName,
              localAddress,
              identityType,
              identityNumber,
              mobile,
              village,
              block,
              tehsil,
              district,
              state,
              country,
              age,
              gender,
              GST_type,
              purchaseType,
              email,
              GST_number,
              firm_type,
              category,
              GST_user,
              zipCode,
              openingBalance,
              openingBalanceDate
            } = candidate;

            this.name.value = name;
            this.propName.value = propName || null ;
            this.localAddress.value = localAddress || null ;
            this.identityType.value = identityType || null ;
            this.identityNumber.value = identityNumber || null ;
            this.mobile.value = mobile || null ;
            this.village.value = village || null ;
            this.block.value = block || null ;
            this.tehsil.value = tehsil || null ;
            this.district.value = district || null ;
            this.state.value = state || null ;
            this.country.value = country || null ;
            this.age.value = age || null ;
            this.gender.value = gender || null ;
            this.GST_type.value = GST_type || null ;
            this.purchaseType.value = purchaseType || null ;
            this.email.value = email || null ;
            this.GST_number.value = GST_number || null ;
            this.firm_type.value = firm_type || null ;
            this.category = category || null;
            this.GST_user.value = GST_user || null ;
            this.zipCode = zipCode || null ;
            this.openingBalance.value = openingBalance || null ;
            // this.openingBalanceDate.value = new Date(openingBalanceDate).toISOString().substr(0, 10);
            this.openingBalanceDate.value = openingBalanceDate ? new Date(openingBalanceDate).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
            if(!this.gDistrict.includes(district)) {
              this.gDistrict.push(district)
            }
            if(!this.gTehsil.includes(tehsil)) {
              this.gTehsil.push(tehsil)
            }
            return;
          }
        }
      }
      this.clear();
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { buyerId } = to.params;
    if (buyerId) {
      this.SET_SELECTED_CUSTOMER(buyerId);
    }
    next();
  }
};
</script>

<style>
#buyerInfo .v-expansion-panel__header {
    background-color: #15155d;
}

#buyerInfo .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
    color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/Buyers/Buyer/BuyerInfo.vue